import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const HeatmapOverlay = ({ interactions, width = 1000, height = 800 }) => {
  const points = useMemo(() => {
    return interactions.filter(i => i.eventName === 'click_interaction' && i.properties?.x);
  }, [interactions]);

  if (points.length === 0) return (
    <div className="flex items-center justify-center p-20 bg-slate-50 rounded-[2rem] border-2 border-dashed border-slate-200 text-slate-400 font-bold italic">
      No spatial data captured for this session
    </div>
  );

  return (
    <div className="relative bg-white rounded-[2rem] border border-slate-200 overflow-hidden shadow-inner" style={{ height: '600px' }}>
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] [background-size:20px_20px]"></div>
      
      {/* Neural Density Legend */}
      <div className="absolute top-6 right-6 z-20 bg-white/90 backdrop-blur px-4 py-2 rounded-xl border border-slate-100 shadow-sm flex items-center gap-3">
        <span className="text-[10px] font-black text-slate-400">DENSITY</span>
        <div className="h-2 w-24 bg-gradient-to-r from-blue-400 via-yellow-400 to-red-500 rounded-full"></div>
      </div>

      <div className="relative w-full h-full overflow-auto p-10">
        <div className="relative mx-auto border border-slate-100 shadow-2xl rounded-xl bg-slate-50" 
             style={{ width: '100%', minHeight: '1200px', transform: 'scale(0.8)', transformOrigin: 'top center' }}>
          
          {points.map((point, idx) => {
            const { x, y } = point.properties;
            // Normalize coordinates for the demo container
            const normX = (x / 1440) * 100;
            const normY = (y / 2000) * 100;

            return (
              <motion.div
                key={idx}
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 0.6 }}
                className="absolute w-12 h-12 -ml-6 -mt-6 rounded-full blur-xl"
                style={{
                  left: `${normX}%`,
                  top: `${normY}%`,
                  background: 'radial-gradient(circle, rgba(239,68,68,0.8) 0%, rgba(245,158,11,0.4) 50%, transparent 100%)'
                }}
              />
            );
          })}

          {/* Interaction Markers */}
          {points.map((point, idx) => (
            <div
              key={`marker-${idx}`}
              className="absolute w-2 h-2 -ml-1 -mt-1 bg-white border-2 border-slate-900 rounded-full z-10 shadow-sm"
              style={{
                left: `${(point.properties.x / 1440) * 100}%`,
                top: `${(point.properties.y / 2000) * 100}%`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeatmapOverlay;